module.exports = __webpack_public_path__ + "assets/img/staff.a5d7498d.png";